import React from 'react';
import classes from './SimpleTableCell.module.css';

type TableCellType = {
  children: React.ReactNode;
  align: 'left' | 'right' | 'center';
  style?: React.CSSProperties;
};

const SimpleTableCell: React.FC<TableCellType> = ({ children, align, style = {} }) => {
  return (
    <td className={classes.cell} style={{ ...style, textAlign: align }}>
      {children}
    </td>
  );
};

export { SimpleTableCell };
